import {ObjectDTO} from './object-dto';

export class LitigeDTO extends ObjectDTO {

  code: string;
  libelle: string;
  actif: boolean;

}
